import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Transition from '../dialogs/Transition';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';
import moment from 'moment';
import 'moment-duration-format';

import _ from "lodash";
import { withStyles } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import FormComponent from "../FormComponent";

//- graphics
import CircularProgress from "@material-ui/core/CircularProgress";
import GreenChecked from '../../images/icons/greenChecked.svg';
import AuthUserContainer from "../../containers/AuthUser";
import FormTextArea from "../form/FormTextArea";
import TimeClockContainer from '../../containers/TimeClock/TimeClock';

function styles () {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitle : {
			fontSize : 20,
			borderBottom : '1px solid #eee',
			paddingBottom : 5,
			marginBottom : 10,
			fontWeight : 300,
			display : 'flex',
			justifyContent : 'space-between',
		},
		dialogRoot: {
			//overflow: 'visible'
			alignItems : 'end'
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		removeButton : {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize : 16,
			marginTop : 20,
			color : 'white',
			marginRight : 10,
			backgroundColor: `#f44336`,
		},

		isSaving : {
			marginLeft : 20,
			fontSize : 16,
			color : '#1565C0',
		},
		savingSuccessful : {
			marginLeft : 20,
			fontSize : 16,
			color : '#2E7D32',
		},
		pleaseSelect : {
			fontStyle : 'italic',
			color : '#777',
		},
		currentShiftContainer : {
			border : `1px solid #eee`,
			backgroundColor : '#fcfcfc',
			padding : `20px 20px`,
			margin : '20px 0px',
			borderRadius : 5,
		},
		currentShiftTitle : {
			display : 'flex',
			alignItems : 'center',
			fontSize : 17,
		},
		errorIcon : {
			color:'#F44336',
			marginRight : 10,
		},
		greenCheckedIcon : {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight : 2,
			marginLeft : 5,
		},
		currentLabel : {
			color : '#666',
			marginLeft : 2,
			marginRight : 5
		},
		currentValue : {
			fontWeight : 500,
		},
	};
}

class RemoveTimeShiftDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isSaving : false,
			savingSuccessful : false,
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { timeClockShift } = this.props;
		if (timeClockShift && prevProps.timeClockShift !== timeClockShift) {
			const { clockInDateTime, clockOutDateTime } = timeClockShift;
			return this.setState({
				clockInDate : clockInDateTime,
				clockInTime : clockInDateTime,
				clockOutDate : clockOutDateTime,
				clockOutTime : clockOutDateTime,
			});
		}
	}

	handleSubmit = () => {
		const {timeClockShiftManagerRemove, showErrors} = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({path, label}) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			return showErrors(_.values(formFieldError));
		}

		const { timeClockShift } = this.props;
		const {
			note,
		} = this.state;

		if (!timeClockShift) {
			return showErrors(['Missing selected time clock shift.']);
		}

		const { timeClockShiftId } = timeClockShift;

		const params = {
			timeClockShiftId,
			note,
		};

		this.setState({ isSaving: true, savingSuccessful : false });
		timeClockShiftManagerRemove({
			params,
			callback: (err, apiResult) => {
				if (err) {
					this.setState({ isSaving : false });
					showErrors(err);
					return;
				}
				_.delay(() => {
					this.props.afterSave({ apiResult });
					this.handleClose();
				}, 400);
			}
		});
	};

	handleClose = () => {
		this.setState({
			savingSuccessful : false,
			isSaving : false,
		});
		this.props.onClose();
	};

	render() {
		const {
			open,
			classes,
		} = this.props;

		const isRequired = true;
		const { isSaving, savingSuccessful } = this.state;

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper : classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitle}>
						<div>
							Remove an Employee's Completed Shift
						</div>
						<div>
							<IconButton aria-label="close" className={classes.closeButton} onClick={this.handleClose}>
								<CloseIcon />
							</IconButton>
						</div>
					</div>

					<form>
						<Grid container spacing={2} style={{marginTop : 0, marginBottom : 0}}>

							{this.renderShowCurrentShift()}

							<FormTextArea
								{...this.setForm('note', 'Reason for shift removal', isRequired)}
								rows={2}
							/>

							<Grid item md={12}>
								<strong style={{fontSize:'120%'}}>Are you sure you want to remove this shift?</strong>
							</Grid>
							<Grid item md={12} style={{display : 'flex', alignItems : 'baseline'}}>
								<Button
									variant="contained"
									color="primary"
									className={classes.removeButton}
									onClick={this.handleSubmit}
									disabled={isSaving || savingSuccessful}
								>
									Yes, I want to remove this employee shift
								</Button>

								<Button variant="outlined" className={classes.button} onClick={this.handleClose}>
									Close
								</Button>

								<Zoom
									in={isSaving}
									style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
									mountOnEnter unmountOnExit
								>
									<div className={classes.isSaving}>
										<CircularProgress style={{verticalAlign : 'middle'}} />
										<span style={{paddingLeft: 10}}>Saving...</span>
									</div>
								</Zoom>

								<Zoom in={savingSuccessful} style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}>
									<div className={classes.savingSuccessful}>
										<div className={classes.greenCheckedIcon}/>
										<span style={{paddingLeft: 10}}>Employee's shift removed successfully.</span>
									</div>
								</Zoom>
							</Grid>
						</Grid>
					</form>
				</div>
			</Dialog>
		);
	}

	renderShowCurrentShift = () => {
		const { classes, timeClockShift, userMap } = this.props;

		if (!timeClockShift) {
			return (
				<Grid item xs={12} >
					<div className={classes.currentShiftContainer}>
						<div className={classes.pleaseSelect}>
							Missing time shift
						</div>
					</div>
				</Grid>
			);
		}

		const { clockInDateTime, clockOutDateTime, shiftForUserId} = timeClockShift;

		if (!clockOutDateTime) {
			const clockInMoment = moment(clockInDateTime);
			const duration = moment.duration(moment().diff(clockInMoment));

			return (<Grid item xs={12}>
				<div className={classes.currentShiftContainer}>
					<div className={classes.currentShiftTitle}>
						<div className={classes.greenCheckedIcon}/>
						Employee is currently logged in
					</div>
					<div style={{marginTop: 7, paddingTop: 7, borderTop: '1px solid #ddd'}}>
						<span className={classes.currentLabel}>Clock in date / time</span>
						<span className={classes.currentValue}>{clockInMoment.format('M/D h:mm a')}</span>
					</div>
					<div style={{marginTop: 5}}>
						<span className={classes.currentLabel}>Current duration</span>
						<span className={classes.currentValue}>
						{moment.duration(duration).format('d [days], h [hrs], m [min]')}
					</span>
					</div>
				</div>
			</Grid>);
		}


		const clockInMoment = moment(clockInDateTime);
		const clockOutMoment = moment(clockOutDateTime);
		const duration = moment.duration(moment(clockOutMoment).diff(clockInMoment));
		const user = userMap[shiftForUserId] ||{ firstName : 'Missing', lastName : ''};

		return (<Grid item xs={12}>
			<div className={classes.currentShiftContainer}>
				<div className={classes.currentShiftTitle}>
					Employee : {user.firstName} {user.lastName}
				</div>
				<div style={{marginTop: 7, paddingTop: 7, borderTop: '1px solid #ddd'}}>
					<span className={classes.currentLabel}>Clock in date / time</span>
					<span className={classes.currentValue}>{clockInMoment.format('M/D h:mm a')}</span>
				</div>
				<div style={{marginTop: 5}}>
					<span className={classes.currentLabel}>Clock out date / time</span>
					<span className={classes.currentValue}>{clockOutMoment.format('M/D h:mm a')}</span>
				</div>
				<div style={{marginTop: 5}}>
					<span className={classes.currentLabel}>Shift Duration</span>
					<span className={classes.currentValue}>
						{moment.duration(duration).format('d [days], h [hrs], m [min]')}
					</span>
				</div>
			</div>
		</Grid>);
	}
}

RemoveTimeShiftDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func,
	timeClockShiftManagerRemove : PropTypes.func.isRequired,
	afterSave : PropTypes.func.isRequired,
	timeClockShift : PropTypes.object,
	userMap : PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	TimeClockContainer,
])(RemoveTimeShiftDialog);
